// extracted by mini-css-extract-plugin
export default {"heading":"HpHeading_heading__jIUn+","heading-vector":"HpHeading_heading-vector__KTyYe","sub-heading":"HpHeading_sub-heading__9hm9G"};